import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

const AperturaCaja = ({ onCajaAbierta }) => {
  const [saldoInicial, setSaldoInicial] = useState('');
  const [tipoCaja, setTipoCaja] = useState('fisica');
  const [error, setError] = useState('');
  const { token } = useAuth();

  useEffect(() => {
    // Verificar si la caja guardada sigue existiendo y está abierta
    const verificarCaja = async () => {
      const cajaId = localStorage.getItem('cajaAbiertaId');
      if (cajaId) {
        try {
          const response = await axios.get(`${import.meta.env.VITE_API_URL}/caja/${cajaId}`, {
            headers: { 'x-auth-token': token },
          });
          if (!response.data || response.data.cerrada) {
            localStorage.removeItem('cajaAbiertaId');
            setError("La caja anterior fue cerrada. Por favor, abra una nueva caja.");
          }
        } catch {
          localStorage.removeItem('cajaAbiertaId');
          setError("La caja anterior fue cerrada. Por favor, abra una nueva caja.");
        }
      }
    };
    if (token) {
      verificarCaja();
    }
  }, [token]);

  const abrirCaja = async () => {
    if (!saldoInicial || isNaN(saldoInicial)) {
      setError('Ingrese un saldo inicial válido.');
      return;
    }

    try {
      const response = await axios.post(`${import.meta.env.VITE_API_URL}/caja/abrir`, {
        saldo_inicial: parseFloat(saldoInicial),
        tipo: tipoCaja,
      }, {
        headers: {
          'x-auth-token': token,
        }
      });
      onCajaAbierta(response.data);
      setError('');
    } catch (error) {
      setError('Error al abrir la caja. Intente nuevamente.');
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-primary text-center mb-4">Apertura de Caja</h2>
      {error && <p className="text-red-500">{error}</p>}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Saldo Inicial
        </label>
        <input
          type="number"
          value={saldoInicial}
          onChange={(e) => setSaldoInicial(e.target.value)}
          className="w-full p-2 border rounded"
          placeholder="Ingrese saldo inicial"
        />
      </div>
      <button
        onClick={abrirCaja}
        className="bg-blue-500 text-white p-2 rounded-md w-full hover:bg-blue-600"
      >
        Abrir Caja
      </button>
    </div>
  );
};

export default AperturaCaja;
